import { ulid } from 'ulid'

export default class AppMessage {
  id: string = ulid()
  message: string = ''
  error: boolean = false
}
